import React from 'react';
import styles from './css/index.module.css';

export default function MemberDetailsModal({ person, onClose }) {
    if (!person) return null;
    const rows = [
        ['Name', person.fullName],
        ['Email', person.email],
        ['Status', person.status === 'pending' ? 'Invitation pending' : 'Active'],
        ['Access Group', person.accessGroupName || '—'],
        ['Administrator status', person.isAdmin ? 'Project Administrator' : 'Member'],
        ['Invitation status', person.status === 'pending' ? (person.expired ? 'Expired' : 'Pending') : 'Accepted'],
    ];
    return (
        <>
            <div className={styles.backdrop} onClick={onClose} />
            <div className={styles.modal} role="dialog" aria-label="Member details">
                <div className={styles.cardHead}>
                    <h2 className={styles.title}>Member details</h2>
                    <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>
                <div className={styles.detailGrid}>
                    {rows.map(([label, value]) => (
                        <div key={label}>
                            <p className={styles.factLabel}>{label}</p>
                            <p className={styles.factValue}>{value}</p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
